import { Chip, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add, InfoOutlined, RotateLeft } from "@material-ui/icons";
import { useAuth } from "@airborne/react-admin";
import React, { useState } from "react";
import {
  BooleanInput,
  Button,
  Create,
  SelectInput,
  TextInput,
  Toolbar,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { ExperienceNoteType } from "../../../../../../src/Enums/ExperienceNoteType";
import { PbhRequestFileType } from "../../../../../../src/Enums/PbhRequestFileType";
import { CustomDatetime } from "../../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../../Components/SectionTitle";
import { Separator } from "../../../../../Components/Separator";
import { GetCarrierType } from "../../../../../Enums/CarrierType";
import { PbhSvcShipmentTypeEnum } from "../../../../../Enums/PbhSvcShipmentType";
import { ServiceableStatu } from "../../../../../Enums/ServiceableStatus";
import { useAppDataProvider } from "../../../../../dataprovider";
import { PbhRequestServiceablePostModel } from "../../../Models/PbhRequestServiceableModel";
import ExperienceSoftWarningDialog from "../../ExperiencePopup";
import OrderTypesEnum from "../../../../../../src/Enums/OrderTypes";
import EightWingsStorageSelectInputs from "../../../../../../src/Components/EightWingsComponents/EightWingsStorageSelectInputs";
import { EightWingsStatus } from "../../../../../../src/Enums/EightWingsTabEnum";
import { Roles } from "../../../../../../src/Enums/Roles";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const ServiceableCreate = props => {
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [shipmentTypeList, setShipmentTypeList] = useState<any[]>([]);
  const [orderTypeList, setOrderTypeList] = useState<any[]>([]);
  const [orderNumberAndTypeVisible, setOrderNumberAndTypeVisible] = useState(false);
  const requestId = props.requestId;

  const classes = useStyles();

  React.useEffect(() => {
    getShipmentTypeList();
    getOrderTypeList();
  }, []);
  const createServiceableButtonClick = e => {
    createServiceable(e);
  };

  const isDisabledProcess = values => () => {
    let isExistFile = props?.requestDetail?.pbhRequestOrderFiles?.some(
      x =>
        x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
        x.pbhRequestFileTypeEnum === PbhRequestFileType.ShopReport
    );
    return !isExistFile;
  };

  const sendToPbh = () => {
    dataProvider
      .post("eightwings/updatestatus", { id: props.eightWingsId, status: EightWingsStatus.SentToPbh })
      .then(result => {
        notify(`Sent To Pbh`, "success", false, true);
        history.push("/pbhrequestorders/" + requestId);
      })
      .catch(result => notify(`${result}`, "error", false, true));
  };

  const createServiceable = async e => {
    let pbhrequestServiceableCreateModel: PbhRequestServiceablePostModel = new PbhRequestServiceablePostModel();
    pbhrequestServiceableCreateModel.RequestId = requestId;
    pbhrequestServiceableCreateModel.Awb = e.awb;
    pbhrequestServiceableCreateModel.CarrierEnum = e.carrierEnum;
    pbhrequestServiceableCreateModel.EstimatedDeliveryDate = e.estimatedDeliveryDate;
    pbhrequestServiceableCreateModel.FlightNo = e.flightNo;
    pbhrequestServiceableCreateModel.Pn = e.pn;
    pbhrequestServiceableCreateModel.Sn = e.sn;
    pbhrequestServiceableCreateModel.Status = ServiceableStatu.Offered;
    pbhrequestServiceableCreateModel.SubmittedBy = user?.employeeId;
    pbhrequestServiceableCreateModel.SubmittedDate = new Date();
    pbhrequestServiceableCreateModel.ForwardDateToCarrier = e.forwardDateToCarrier;
    pbhrequestServiceableCreateModel.XoNo = e.xoNo;
    pbhrequestServiceableCreateModel.ShipmentType = Number(e.shipmentType);
    pbhrequestServiceableCreateModel.IsCid = e.isCid;
    pbhrequestServiceableCreateModel.CidDescription = e.cidDescription;
    if (orderNumberAndTypeVisible) {
      pbhrequestServiceableCreateModel.OrderNumber = e.orderNumber;
      pbhrequestServiceableCreateModel.OrderType = e.orderType;
    }

    postCreate(pbhrequestServiceableCreateModel);
  };

  const postCreate = async (createModel: PbhRequestServiceablePostModel) => {
    setLoading(true);
    dataProvider
      .post("eightwings/serviceablecreate", createModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record created`, "success", false, true);
        history.push("/eightwings/" + props.eightWingsId + "/1");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const getShipmentTypeList = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
        filter: { parameterGroupCode__eq: PbhSvcShipmentTypeEnum.PbhSvcShipmentType },
      })
      .then(result => {
        setShipmentTypeList(result?.data ?? []);
      })
      .catch(result => console.error(result));
  };

  const getOrderTypeList = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
        filter: { parameterGroupCode__eq: OrderTypesEnum.OrderTypes },
      })
      .then(result => {
        setOrderTypeList(result?.data ?? []);
      })
      .catch(result => console.error(result));
  };

  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };

  const onChangeShipType = e => {
    if (Number(e.target.value) === Number(PbhSvcShipmentTypeEnum.DropShipment)) {
      setOrderNumberAndTypeVisible(true);
    } else {
      setOrderNumberAndTypeVisible(false);
    }
  };

  return (
    <>
      <Form
        onSubmit={createServiceableButtonClick}
        render={({ handleSubmit, form, values }) => (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Create {...props}>
                  <>
                    <Separator />
                    <Grid {...gridContainerProps}>
                      <Grid container xs={12} sm={12} justifyContent="center">
                        <SectionTitle label="Serviceable Info" />
                      </Grid>
                      <Grid container xs={12} sm={12} justifyContent="flex-end" style={{ margin: 5 }}>
                        <Chip
                          color="primary"
                          variant="outlined"
                          label="Please Upload Shop Report File"
                          icon={<InfoOutlined />}
                        />
                      </Grid>
                    </Grid>

                    <Separator />
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        <EightWingsStorageSelectInputs
                          isUpdate={false}
                          form={form}
                          requirementCategoryList={props?.requestDetail?.requirementCategoryList}
                          selectedRequirementCategory={props?.requestDetail?.requirementCategory}
                        />
                        <TextInput source="flightNo" label="Flight No" fullWidth resettable variant="outlined" />
                        <CustomDatetime
                          fullWidth
                          source="forwardDateToCarrier"
                          label="Forward Date To Carrier"
                          inputVariant={"dialog"}
                          variant="outlined"
                          showTime
                          validate={required()}
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                        />
                        <SelectInput
                          source="shipmentType"
                          label="Shipment Type"
                          choices={shipmentTypeList}
                          optionText="parameterDesc"
                          optionValue="parameterValue"
                          fullWidth
                          onChange={onChangeShipType}
                          variant="outlined"
                          validate={required()}
                        />
                        {orderNumberAndTypeVisible && (
                          <TextInput
                            source="orderNumber"
                            label="Order Number"
                            fullWidth
                            resettable
                            variant="outlined"
                            validate={required()}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="awb"
                          label="AWB No"
                          fullWidth
                          resettable
                          variant="outlined"
                          validate={required()}
                        />
                        <TextInput source="xoNo" label="XO Number" fullWidth resettable variant="outlined" />
                        <SelectInput
                          source="carrierEnum"
                          label="Carrier"
                          choices={GetCarrierType}
                          optionText="Description"
                          optionValue="Value"
                          fullWidth
                          variant="outlined"
                          validate={required()}
                        />
                        <CustomDatetime
                          fullWidth
                          source="estimatedDeliveryDate"
                          label="Estimated Delivery Date"
                          inputVariant={"dialog"}
                          variant="outlined"
                          showTime
                          minDate={values.forwardDateToCarrier}
                          validate={[minValue(values.forwardDateToCarrier), required()]}
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                        />
                        {orderNumberAndTypeVisible && (
                          <SelectInput
                            source="orderType"
                            label="Order Type"
                            choices={orderTypeList}
                            optionText="parameterDesc"
                            optionValue="parameterValue"
                            fullWidth
                            validate={required()}
                            variant="outlined"
                          />
                        )}
                        <BooleanInput
                          label="Received as damaged, but it will be installed on aircraft"
                          source="isCid"
                          disabled={user?.isCustomer === false}
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}></Grid>
                      <Grid item xs={12} sm={5}>
                        {values.isCid == true && (
                          <TextInput
                            disabled={user?.isCustomer === false}
                            source="cidDescription"
                            label="Cid Remark"
                            multiline
                            minRows={3}
                            fullWidth
                            resettable
                            variant="outlined"
                          />
                        )}
                      </Grid>
                    </Grid>
                    <Separator />

                    <Toolbar {...props} placeholder="" classes={classes}>
                      {user?.roles?.includes?.(Roles.EightWings) && (
                        <Button
                          label={loading ? "Serviceable is creating!" : "Create Serviceable"}
                          disabled={loading ? true : isDisabledProcess(values)()}
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                          style={{ margin: "8px" }}
                        >
                          {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                        </Button>
                      )}
                      {user?.isCustomer === false && (
                        <Button
                          label={loading ? "Sending!" : "Send to Pbh"}
                          size="medium"
                          variant="contained"
                          color="default"
                          onClick={sendToPbh}
                          style={{ margin: "8px" }}
                        >
                          {loading ? <CircularProgress size="2rem" color="secondary" /> : <RotateLeft />}
                        </Button>
                      )}
                    </Toolbar>
                  </>
                </Create>
              </Grid>
            </Grid>
          </form>
        )}
      />
      <ExperienceSoftWarningDialog data={props?.requestDetail?.experience} type={ExperienceNoteType.Serviceable} />
    </>
  );
};

const EightWingsServiceableCreate = props => {
  return (
    <ServiceableCreate
      resource="Eightwings Serviceables"
      basePath=""
      requestId={props?.requestId}
      eightWingsId={props?.eightWingsId}
      requestDetail={props?.requestDetail}
      finalCallBack={e => props.finalCallBack()}
    />
  );
};

export default EightWingsServiceableCreate;
